// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
  aws_project_region: "us-east-2",
  aws_content_delivery_bucket: "calbit.live",
  aws_content_delivery_bucket_region: "us-east-2",
  aws_content_delivery_url:
    "http://calbit.live.s3-website.us-east-2.amazonaws.com",
  aws_cognito_identity_pool_id:
    "us-east-2:6d654a41-2d06-45ac-92a5-60c3fe635377",
  aws_cognito_region: "us-east-2",
  aws_user_pools_id: "us-east-2_wclEimhDC", //latest phone
  aws_user_pools_web_client_id: "2kq3o8mn7cprm9kmbigf2p6b8u", //latest phone
  oauth: {},
  aws_appsync_graphqlEndpoint:
    "https://re5ooud3xzczlamoi5fdiignje.appsync-api.us-east-2.amazonaws.com/graphql",
  aws_appsync_region: "us-east-2",
  aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS",
  aws_user_files_s3_bucket: "calbitwebappuploadbucket1254-dev",
  aws_user_files_s3_bucket_region: "us-east-2"
};

export default awsmobile;



// WEBPACK FOOTER //
// ./src/aws-exports.js